export default window.console;
/**
 * Keeps the interface consistent to the node logger.
 * @returns window.console
 */
export const initLogger = () => window.console;
